<template lang="html">
  <div class="body">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      @load="loadMore"
    >
      <van-cell
        v-for="comment in comments"
        :key="comment.id"
      >
        <van-skeleton
          avatar
          avatar-shape="square"
          avatar-size="50"
          :row="3"
          :loading="skeletonLoading"
        >
          <CommentDetail
            :comment-id="comment.id"
            :showThread="false"
            :show-actions="false"
          />
          <van-row>
            <van-col offset="2" span="22">
              <EpisodeCard
                v-if="!comment.parent"
                :compact="true"
                :showDescription="false"
                :showRating="false"
                :showPubtime="false"
                :episodeId="comment.object_id"
              />
              <EpisodeCard
                v-if="comment.parent"
                :compact="true"
                :showDescription="false"
                :showRating="false"
                :showPubtime="false"
                :parentCommentId="comment.parent"
              />
            </van-col>
          </van-row>
        </van-skeleton>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { List } from 'vant'
  import { Cell, CellGroup } from 'vant'
  import { Skeleton } from 'vant'
  import CommentDetail from './comment-detail.vue'
  import EpisodeCard from './episode-card.vue'
  Vue.use(List)
  Vue.use(Cell).use(CellGroup)
  Vue.use(Skeleton)
  export default {
    components: {
      CommentDetail,
      EpisodeCard
    },
    props: {
      limit: {
        type: Number,
        default: 0
      },
      iWrote: {
        type: Boolean,
        default: false
      },
      iLike: {
        type: Boolean,
        default: false
      },
      replyToMe: {
        type: Boolean,
        default: false
      },
    },
    computed: {
    },
    watch: {
      iWrote (newVal, oldVal) {
        window.console.log("iWrote属性变化")
        window.console.log(newVal)
        window.console.log(oldVal)
      },
      slug (newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this.getComments()
        }
      }
    },
    data () {
      return {
        slug: '',
        comments: [],
        next: '',
        skeletonLoading: true,
        loading: false,
        finished: false,
        finishedText: '没有更多了'
      }
    },
    methods: {
      getComments () {
        let that = this
        let params = {
          slug: that.slug,
          i_wrote: that.iWrote,
          i_like: that.iLike,
          reply_to_me: that.replyToMe
        }
        that.$api.comment.list(params).then(res => {
          window.console.log("获取到评论列表")
          window.console.log(res)
          that.next = res.data.next
          that.loading = false
          that.skeletonLoading = false
          if (res.data.next == null) {
            that.finished = true
          }
          if (that.limit > 0) {
            that.comments = res.data.results.slice(0, that.limit)
          } else {
            that.comments = res.data.results
          }
        })
      },
      loadMore () {
        let that = this
        if (that.next) {
          that.loading = true
          let url = that.next.split('/api/')[1]
          that.$api.normal.load(url).then(res => {
            that.comments = that.comments.concat(res.data.results)
            that.next = res.data.next
            that.loading = false
            if (that.next == null) {
              that.finished = true
            }
          })
        } else {
          if (that.next === null) {
            that.finished = true
          }
        }
      }
    },
    mounted () {
      this.slug = this.$route.params.slug
      // this.getComments()
    }
  }
</script>

<style lang="css" scoped>
  .body {
    background: #fff;
  }
</style>
